import { useEffect } from "react";
import { initPostHog } from "@/fetchData/posthog";
import { useUISlice } from "@/models/useUISlice";
import Desktop from "@/ui/PageDesktop";
import Chat from "@/ui/PageMobile";

export default function WebApp() {
  const isMobile = useUISlice((state) => state.device.isMobile);

  useEffect(() => {
    initPostHog();
  }, []);

  if (isMobile) return <Chat />;

  return <Desktop />;
}
